<app-alert *ngIf="helperService.showAlert" [type]=helperService.typeAlert [Message]=helperService.messageAlert></app-alert>
<div class="Spinner" *ngIf="isLoading"><mat-spinner></mat-spinner></div>
<section
  class="section-reservation-hour"
  [formGroup]="formValidation"
  [ngClass]="{ isLoading: isLoading }"
>
  <div class="reservation">
    <app-i-my-reservation
      [tip_service]="ToSName"
      [kilometraje]="formValidation.value.kilometraje"
      [taller]="workShopName"
      [asesor]="advisorName"
      [date]="date"
      [time]="time"
      [cityName]="cityName"
      [LanguageForCountry]="recievedLanguageForCountry"
      [make]="makeName"
      [brandUrl]="recievedBrand"
    ></app-i-my-reservation>
  </div>

  <div class="content-reservation-hour">
    <mat-stepper class="choose-service">
      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="formValidation" class="create-form-container">
          <ng-template matStepperIcon="number" let-index="index">
            <span>{{ index + 1 }}.</span>
          </ng-template>
          <ng-template matStepLabel>{{
            "SelectYourService" | translate | uppercase
          }}</ng-template>
          <ng-template #loading>
            <div class="Spinner"><mat-spinner></mat-spinner></div
          ></ng-template>
          <div
            class="grid-container-service service-info"
            *ngIf="!loadingrescheduler; else loading"
          >
            <div class="form-Text-title">
              <mat-label class="initial-text"
                >{{ "servicedetails" | translate }}
              </mat-label>
            </div>
            <div class="form-Text-title"></div>
            <div class="form-input-select">
              <p class="form-text-label">{{ "TypeOfService" | translate }}</p>
              <mat-form-field appearance="outline">
                <!-- <mat-label>{{ "Select" | translate }}</mat-label> -->

                <mat-select
                  formControlName="typeCar"
                  placeholder="{{ 'Select' | translate }}"
                >
                  <mat-option
                    *ngFor="let Department of Departments"
                    [value]="Department.Code"
                    (click)="filterDepartments(Department)"
                  >
                    {{ Department.Description }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="
                  typeCarControl?.invalid &&
                  (typeCarControl?.touched || typeCarControl?.dirty)
                "
              >
                <p class="error-ms">{{ "ObligatoryField" | translate }}</p>
              </div>
            </div>
            <div class="form-input-select" *ngIf="recievedBrand ==='8'">
                <p class="form-text-label">{{"Make" |translate | capitalize}}</p>
                <mat-form-field appearance="outline">
                  <mat-label>{{"Select" |translate}}</mat-label>

                  <mat-select
                    formControlName="makeCar"

                  >

                  <mat-option

                      *ngFor="let Make of Makes"
                      [value]="Make.Code"
                      (click)="filterMakes(Make)"
                    >
                      {{Make.Description}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div
                  *ngIf="
                  makeCarControl?.invalid &&
                    (makeCarControl?.touched || makeCarControl?.dirty)
                  "
                >
                  <p class="error-ms">{{"ObligatoryField" |translate}}</p>
                </div>
              </div>
            <div class="form-input-select">
              <p class="form-text-label">
                {{ "ServiceCategory" | translate }}
                <i
                  *ngIf="
                    recievedCountryData.toString() !== '3' && recievedCountryData.toString() !== '8'
                  "
                  class="bi bi-exclamation-circle"
                  [id]="'exclamation'"
                  (mouseover)="
                    onIconMouseHoverAndOut(
                      'exclamation',
                      'bi-exclamation-circle',
                      true
                    )
                  "
                  (mouseout)="
                    onIconMouseHoverAndOut(
                      'exclamation',
                      'bi-exclamation-circle',
                      false
                    )
                  "
                  #tooltip="matTooltip"
                  (click)="
                    onIconClick(
                      'exclamation',
                      'bi-exclamation-circle',
                      tooltip
                    )
                  "
                  matTooltip="{{ PlaceHolderObservations }}"
                  matTooltipPosition="above"
                ></i>
              </p>
              <mat-form-field appearance="outline">
                <!-- <mat-label>{{ "Select" | translate }}</mat-label> -->

                <mat-select
                  formControlName="tip_service"
                  placeholder="{{ 'Select' | translate }}"
                >
                  <mat-option
                    *ngFor="let Service of Services"
                    [value]="Service.Id"
                    (click)="filterservice(Service)"
                  >
                    {{ Service.Name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="
                  tip_serviceControl?.invalid &&
                  (tip_serviceControl?.touched || tip_serviceControl?.dirty)
                "
              >
                <p class="error-ms">{{ "ObligatoryField" | translate }}</p>
              </div>
            </div>

            <div class="form-input-select">
              <p class="form-text-label">{{ "Mileage" | translate }}</p>
              <mat-form-field appearance="outline">
                <!-- <mat-label> {{ "Mileage" | translate }} </mat-label> -->
                <input
                  matInput
                  formControlName="kilometraje"
                  autocomplete="off"
                  oninput="value = value.replace(/[^0-9]/g, '')"
                  maxlength="6"
                />
              </mat-form-field>
              <div
                *ngIf="
                  kilometrajeControl?.invalid &&
                  (kilometrajeControl?.touched || kilometrajeControl?.dirty)
                "
              >
                <p
                  class="error-ms"
                  *ngIf="kilometrajeControl.errors?.['required']"
                >
                  {{ "ObligatoryField" | translate }}
                </p>
                <p
                  class="error-ms"
                  *ngIf="kilometrajeControl.errors?.['pattern']"
                >
                  {{ "ObligatoryNumbers" | translate }}
                </p>
              </div>
            </div>
            <!-- <div class="form-input-select"></div> -->

            <!-- Detalles de servicio from -->

            <div class="form-input-select">
              <p class="form-text-label">{{ "Advisor" | translate }}</p>
              <mat-form-field appearance="outline">
                <!-- <mat-label>{{ "Select" | translate }}</mat-label> -->

                <mat-select
                  formControlName="asesor"
                  placeholder="{{ 'Select' | translate }}"
                >
                  <mat-option
                    *ngFor="let resource of resources"
                    [value]="resource.Id"
                    (click)="filterResources(resource)"
                  >
                    {{ resource.Description }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="
                  asesorControl?.invalid &&
                  (asesorControl?.touched || asesorControl?.dirty)
                "
              >
                <p class="error-ms">{{ "ObligatoryField" | translate }}</p>
              </div>
            </div>
            <div class="form-input-select">
              <p class="form-text-label">{{ "Comments" | translate }}</p>
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label></mat-label>
                <textarea
                  matInput
                  formControlName="observations"
                  maxlength="4000"
                  placeholder="{{ PlaceHolderObservations }}"
                  oninput="value = value.replace(/[^a-zA-Z0-9 ñáéíóúÁÉÍÓÚ$()#\-_.¿?%]/g, '')"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="Spinner" *ngIf="isLoadingCalendar">
            <mat-spinner></mat-spinner>
          </div>
          <!---------------------Espacio Calendario---------------------->
          <app-i-calendar-web
            *ngIf="showCalendar && !loadingrescheduler"
            (timeChanged)="timeValue($event)"
            (dateChanged)="dateValue($event)"
            (slotDurationChanged)="slotDuration($event)"
            [receivedTokenIncadea]="receivedTokenIncadea"
            [receivedcompaniesSelect]="receivedcompaniesSelect"
            [receivedlocationSelect]="receivedlocationSelect"
            [servicesSelect]="servicesSelect"
            [resourcesSelect]="resourcesSelect"
            [receivedBackEndCode]="receivedBackEndCode"
          ></app-i-calendar-web>
          <!---------------------End Espacio Calendario--------------------->
          <!--<pre> {{ formValidation.value | json }}</pre>-->

          <!-- start comments for derco chile -->
          <div
            class="comments-container"
            [innerHTML]="getTermsAndCondition.Observations"
            *ngIf="recievedBrand ==='8'&& recievedCountryData ==='3'  && getTermsAndCondition.Observations !==''"
          >
            <!-- <h3>Observaciones:</h3>
            <li type="disc"><a href="https://www.dercocenter.cl/garantias" target="_blank">Derechos y Obligaciones Asociados a la Garantía de tu Vehículo y Plan de Mantenimiento</a></li> -->
            {{getTermsAndCondition.Observations}}
          </div>
          <!-- End comments for derco chile -->
          <div class="container-btn-reservation">
            <button
              mat-raised-button
              class="btn-reservation"
              (click)="backInitialChoose()"
            >
              {{ "Back" | translate }}
            </button>

            <button
              mat-raised-button
              class="btn-reservation-sig"
              type="button"
              matStepperNext
              [disabled]="nextDisabled()"
              id="next-step1"
            >
              {{ "Next" | translate }}
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="firstFormGroup">
        <form [formGroup]="formValidation2">
          <ng-template matStepLabel>{{
            CompleteData | translate | uppercase
          }}</ng-template>
          <section class="section-complete-reserv">
            <div class="content-complete-reserv">
              <div class="container-fomr" [formGroup]="formValidation2">
                <h3 class="input-title-blue" *ngIf="isNewSchedule()">
                  {{ "CustomerAndVehicleData" | translate }}
                </h3>
                <h3 class="input-title-blue" *ngIf="!isNewSchedule()">
                  {{ "VehicleData" | translate }}
                </h3>
                <div class="content-data">
                  <div class="form-input" *ngIf="isNewSchedule()">
                    <p *ngIf="isNewSchedule() && recievedCountryData === '3'">
                      <strong>{{ "RUT" | translate }} </strong>
                      <!-- <span style="color: red">*</span> -->
                    </p>
                    <p *ngIf="isNewSchedule() && recievedCountryData === '6'">
                      <strong>{{ "IdentityOrLegalCard" | translate }} </strong>
                      <!-- <span style="color: red">*</span> -->
                    </p>
                    <p *ngIf="isNewSchedule() && recievedCountryData === '5'">
                      <strong
                        >{{ "IdentityDocumentOrRUC" | translate }}
                      </strong>
                      <!-- <span style="color: red">*</span> -->
                    </p>
                    <p *ngIf="isNewSchedule() && recievedCountryData === '8'">
                      <strong>{{ "DocumentNo" | translate }}</strong>
                      <i
                        class="bi bi-exclamation-circle"
                        [id]="'exclamation'"
                        (mouseover)="
                          onIconMouseHoverAndOut(
                            'exclamation',
                            'bi-exclamation-circle',
                            true
                          )
                        "
                        (mouseout)="
                          onIconMouseHoverAndOut(
                            'exclamation',
                            'bi-exclamation-circle',
                            false
                          )
                        "
                        #tooltip="matTooltip"
                        (click)="
                          onIconClick(
                            'exclamation',
                            'bi-exclamation-circle',
                            tooltip
                          )
                        "
                        matTooltip="{{ tooltipDocumentType }}"
                        matTooltipPosition="above"
                      ></i>
                      <!-- <span style="color: red">*</span> -->
                    </p>
                    <mat-form-field
                      appearance="outline"
                      *ngIf="isNewSchedule()"
                    >
                      <input
                        matInput
                        autocomplete="off"
                        formControlName="cedula"
                        maxlength="20"
                       oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                      />
                    </mat-form-field>
                    <div *ngIf="isNewSchedule() && recievedCountryData === '3'">
                      <p class="mensagePatentModel">
                        {{ "Example" | translate }}: 1111111-1
                      </p>
                    </div>
                    <div
                      *ngIf="
                        cedulaControl?.invalid &&
                        (cedulaControl?.touched || cedulaControl?.dirty)
                      "
                    >
                      <p
                        class="error-ms"
                        *ngIf="cedulaControl.errors?.['required']"
                      >
                        {{ "ObligatoryField" | translate }}
                      </p>
                      <p
                        class="error-ms"
                        *ngIf="cedulaControl.errors?.['pattern']"
                      >
                        {{ "ObligatoryNumbers" | translate }}
                      </p>
                      <p
                        class="error-ms"
                        *ngIf="cedulaControl.errors?.['minlength']"
                      >
                        {{ "MinimumCharacters" | translate }}
                      </p>
                    </div>
                  </div>

                  <div class="form-input plate">
                    <p *ngIf="recievedCountryData === '3'">
                      <strong>{{ "Patent" | translate }}</strong>
                    </p>
                    <p *ngIf="isNewSchedule() && recievedCountryData === '8'">
                      <strong>
                        {{ "LicensePlate" | translate }}
                        <!-- <span style="color: red">*</span> -->
                      </strong>
                    </p>
                    <p
                      *ngIf="
                        recievedCountryData !== '3' &&
                        recievedCountryData !== '8'
                      "
                      class="reschedule-plate-label"
                    >
                      <strong
                        >{{ "LicensePlate" | translate }}
                        <!-- <span style="color: red">*</span> -->
                      </strong>
                    </p>
                    <div class="plate-cont">
                      <mat-form-field
                        appearance="outline"
                        *ngIf="isNewSchedule()"
                      >
                        <input
                          matInput
                          autocomplete="off"
                          formControlName="placa"
                          maxlength="10"
                         oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                          (change)="transformInput($event)"
                        />
                      </mat-form-field>

                      <p *ngIf="!isNewSchedule()" class="reshedule-plate-text">
                        {{ formValidation2.value.placa }}
                      </p>
                      <button
                        mat-raised-button
                        [disabled]="SerchPlate()"
                        class="btn-icon"
                        *ngIf="isNewSchedule()"
                        (click)="onPlateNumberSearchClick()"
                      >
                        <i class="bi bi-search"></i>
                      </button>
                    </div>

                    <div *ngIf="isNewSchedule() && recievedCountryData === '3'">
                      <p class="mensagePatentModel">
                        {{ "Example" | translate }}: AABB12
                      </p>

                      <div
                        *ngIf="
                          placaControl?.invalid &&
                          (placaControl?.touched || placaControl?.dirty)
                        "
                      >
                        <p
                          class="error-ms"
                          *ngIf="placaControl.errors?.['required']"
                        >
                          {{ "ObligatoryField" | translate }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <br />
                <div class="Spinner" *ngIf="loadingSerchPlate">
                  <mat-spinner></mat-spinner>
                </div>
                <div class="fill-details" *ngIf="details === isNewSchedule()">
                  <h3 *ngIf="edited === true" class="input-title-blue">
                    {{ "VerifyDataOwner" | translate }}
                  </h3>
                  <h3 *ngIf="edited2 === false" class="input-title-blue">
                    {{ "CompleteDataOwner" | translate }}
                  </h3>
                  <div class="grid-container-service owner-info">
                    <div class="form-input-select">
                      <div class="item-form">
                        <div>
                          <p>
                            <strong>{{ "DocumentType" | translate }}</strong>
                          </p>
                          <mat-form-field appearance="outline">
                            <mat-select formControlName="tip_Doc">
                              <mat-option
                                *ngFor="let typeofdocument of documentType"
                                [value]="typeofdocument.typeId"
                                (click)="NameDocument(typeofdocument)"
                              >
                                {{ typeofdocument.typeName }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>

                          <div
                            *ngIf="
                              tip_DocControl?.invalid &&
                              (tip_DocControl?.touched || tip_DocControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="tip_DocControl.errors?.['required']"
                            >
                              {{ "ObligatoryField" | translate }}
                            </p>
                          </div>
                        </div>

                        <div>
                          <p>
                            <strong>{{ "DocumentNo" | translate }}</strong>
                          </p>
                          <mat-form-field appearance="outline">
                            <input
                              matInput
                              formControlName="cedula"
                             oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                              maxlength="20"
                              autocomplete="off"
                            />
                          </mat-form-field>

                          <div
                            *ngIf="
                              cedulaControl?.invalid &&
                              (cedulaControl?.touched || cedulaControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="cedulaControl.errors?.['required']"
                            >
                              {{ "ObligatoryField" | translate }}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="cedulaControl.errors?.['pattern']"
                            >
                              {{ "ObligatoryNumbers" | translate }}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="cedulaControl.errors?.['minlength']"
                            >
                              {{ "MinimumCharacters" | translate }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-input">
                      <div class="item-form-input">
                        <div>
                          <p>
                            <strong>{{ "FirstName" | translate }}</strong>
                          </p>

                          <mat-form-field appearance="outline">
                            <input
                              matInput
                              autocomplete="off"
                              formControlName="nombres"
                             oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                              maxlength="100"
                            />
                          </mat-form-field>
                          <div
                            *ngIf="
                              nombresControl?.invalid &&
                              (nombresControl?.touched || nombresControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="nombresControl.errors?.['required']"
                            >
                              {{ "ObligatoryField" | translate }}
                            </p>
                          </div>
                        </div>

                        <div>
                          <p>
                            <strong>{{ "LastName" | translate }}</strong>
                          </p>
                          <mat-form-field appearance="outline">
                            <input
                              matInput
                              autocomplete="off"
                              formControlName="apellidos"
                             oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                              maxlength="100"
                            />
                          </mat-form-field>
                          <div
                            *ngIf="
                              apellidosControl?.invalid &&
                              (apellidosControl?.touched ||
                                apellidosControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="apellidosControl.errors?.['required']"
                            >
                              {{ "ObligatoryField" | translate }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-input">
                      <div class="item-form-input">
                        <div>
                          <p>
                            <strong>{{ "Phone" | translate }}</strong>
                          </p>
                          <mat-form-field appearance="outline">
                            <!-- <mat-label>{{ "Phone" | translate }}</mat-label> -->

                            <input
                             autocomplete="off"
                              matInput
                              formControlName="celular"
                              oninput="value = value.replace(/[^0-9\+]/g, '')"
                              maxlength="20"
                            />
                          </mat-form-field>
                          <div
                            *ngIf="
                              celControl?.invalid &&
                              (celControl?.touched || celControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="celControl.errors?.['required']"
                            >
                              {{ "ObligatoryField" | translate }}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="celControl.errors?.['pattern']"
                            >
                              {{ "ObligatoryNumbers" | translate }}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="celControl.errors?.['minlength']"
                            >
                              {{ "MinimumCharacters" | translate }}
                            </p>
                          </div>
                        </div>

                        <div>
                          <p>
                            <strong>{{ "Email" | translate }}</strong>
                          </p>
                          <mat-form-field appearance="outline">
                            <input
                              matInput
                              autocomplete="off"
                              formControlName="correo"
                              maxlength="100"
                            />
                          </mat-form-field>
                          <div
                            *ngIf="
                              correoControl?.invalid &&
                              (correoControl?.touched || correoControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="correoControl.errors?.['required']"
                            >
                              {{ "ObligatoryField" | translate }}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="correoControl.errors?.['invalidEmail']"
                            >
                              {{ "Invalidemail" | translate }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-input">
                      <div class="item-form-input">
                        <div *ngIf="!isNewUser">
                          <p>
                            <strong>VIN</strong>
                          </p>
                          <mat-form-field appearance="outline">
                            <input
                              matInput
                              formControlName="vin"
                              autocomplete="off"
                              oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                              maxlength="20"
                              class="vin-input"
                            />
                          </mat-form-field>
                          <div
                            *ngIf="
                              vinControl?.invalid &&
                              (vinControl?.touched || vinControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="vinControl.errors?.['required']"
                            >
                              {{ "ObligatoryField" | translate }}
                            </p>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div class="info-owner" *ngIf="details === isNewSchedule()">
                  <div class="container-raddio">
                    <h3>{{ "OwnerWillBeOnSite" | translate }}</h3>
                    <div class="custom-radio">
                      <input
                        #isOwnerRadio
                        name="isOwnerOnSite"
                        formControlName="isOwnerOnSite"
                        value="true"
                        type="radio"
                        [(ngModel)]="selectOwnerOnSite"
                        id="custom-radio1"
                        (change)="toBoolean($event)"
                      />
                      <label for="custom-radio1">{{ "Yes" | translate }}</label>
                    </div>
                    <div class="custom-radio">
                      <input
                        name="isOwnerOnSite"
                        formControlName="isOwnerOnSite"
                        type="radio"
                        id="custom-radio2"
                        value="false"
                        [(ngModel)]="selectOwnerOnSite"
                        (change)="toBoolean($event)"
                      />
                      <label for="custom-radio2">No</label>
                    </div>
                  </div>
                  <!--AQUI TERMINA EL FORMULARIO COMPLETE DATOS DEL PROPIETARIO-->
                  <div
                    class="section-representante"
                    *ngIf="
                      isOwnerOnSite === false && details === isNewSchedule()
                    "
                    [formGroup]="formValidation_representative"
                  >
                    <h3 class="input-title-blue">
                      {{ "RepresentativeData" | translate }}
                    </h3>
                    <div class="grid-container-service representative-info">
                      <div class="form-input-select">
                        <div class="item-form">
                          <div>
                            <p>
                              <strong>{{ "DocumentType" | translate }}</strong>
                            </p>
                            <mat-form-field appearance="outline">
                              <!-- <mat-label>{{ "Select" | translate }}</mat-label> -->

                              <mat-select
                                formControlName="representativeDocumentType"
                                placeholder="{{ 'Select' | translate }}"
                              >
                                <mat-option
                                  *ngFor="let typeofdocument of documentType"
                                  [value]="typeofdocument.typeId"
                                >
                                  {{ typeofdocument.typeName }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeDocumentTypeControl?.invalid &&
                                (representativeDocumentTypeControl?.touched ||
                                  representativeDocumentTypeControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeDocumentTypeControl.errors?.['required']"
                              >
                                El campo es Obligatorio
                              </p>
                            </div>
                          </div>

                          <div>
                            <p>
                              <strong>{{ "DocumentNo" | translate }}</strong>

                              <i *ngIf="recievedCountryData === '8'"
                                class="bi bi-exclamation-circle"
                                [id]="'exclamationRepresentative'"
                                (mouseover)="
                                  onIconMouseHoverAndOut(
                                    'exclamationRepresentative',
                                    'bi-exclamation-circle',
                                    true
                                  )
                                "
                                (mouseout)="
                                  onIconMouseHoverAndOut(
                                    'exclamationRepresentative',
                                    'bi-exclamation-circle',
                                    false
                                  )
                                "
                                #tooltip="matTooltip"
                                (click)="
                                  onIconClick(
                                    'exclamationRepresentative',
                                    'bi-exclamation-circle',
                                    tooltip
                                  )
                                "
                                matTooltip="{{ tooltipDocumentType }}"
                                matTooltipPosition="above"
                              ></i>

                            </p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                autocomplete="off"
                                formControlName="representativeDocumentNumber"
                                oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                                maxlength="20"
                              />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeDocumentNumberControl?.invalid &&
                                (representativeDocumentNumberControl?.touched ||
                                  representativeDocumentNumberControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeDocumentNumberControl.errors?.['required']"
                              >
                                {{ "ObligatoryField" | translate }}
                              </p>
                              <p
                                class="error-ms"
                                *ngIf="representativeDocumentNumberControl.errors?.['pattern']"
                              >
                                {{ "ObligatoryNumbers" | translate }}
                              </p>
                              <p
                                class="error-ms"
                                *ngIf="representativeDocumentNumberControl.errors?.['minlength']"
                              >
                                {{ "MinimumCharacters" | translate }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-input">
                        <div class="item-form-input">
                          <div>
                            <p>
                              <strong>{{ "FirstName" | translate }}</strong>
                            </p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                autocomplete="off"
                                formControlName="representativeName"
                               oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                                maxlength="100"
                              />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeNameControl?.invalid &&
                                (representativeNameControl?.touched ||
                                  representativeNameControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeNameControl.errors?.['required']"
                              >
                                {{ "ObligatoryField" | translate }}
                              </p>
                            </div>
                          </div>

                          <div>
                            <p>
                              <strong>{{ "LastName" | translate }}</strong>
                            </p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                autocomplete="off"
                                formControlName="representativeLastName"
                               oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,_-]/g, '')"
                                maxlength="100"
                              />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeLastNameControl?.invalid &&
                                (representativeLastNameControl?.touched ||
                                  representativeLastNameControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeLastNameControl.errors?.['required']"
                              >
                                {{ "ObligatoryField" | translate }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-input">
                        <div class="item-form-input">
                          <div>
                            <p>
                              <strong>{{ "Phone" | translate }}</strong>
                            </p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                autocomplete="off"
                                formControlName="representativePhone"
                                oninput="value = value.replace(/[^0-9\+]/g, '')"
                                maxlength="20"
                              />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativePhoneControl.invalid &&
                                (representativePhoneControl.touched ||
                                  representativePhoneControl.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativePhoneControl.errors?.['required']"
                              >
                                {{ "ObligatoryField" | translate }}
                              </p>
                              <p
                                class="error-ms"
                                *ngIf="representativePhoneControl.errors?.['pattern']"
                              >
                                {{ "ObligatoryNumbers" | translate }}
                              </p>
                            </div>
                          </div>
                          <div>
                            <p>
                              <strong>{{ "Email" | translate }}</strong>
                            </p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                autocomplete="off"
                                formControlName="representativecorreo"
                                maxlength="100"
                              />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativecorreoControl?.invalid &&
                                (representativecorreoControl?.touched ||
                                  representativecorreoControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativecorreoControl.errors?.['required']"
                              >
                                {{ "ObligatoryField" | translate }}
                              </p>
                              <p
                                class="error-ms"
                                *ngIf="representativecorreoControl.errors?.['invalidEmail']"
                              >
                                {{ "Invalidemail" | translate }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-input">
                        <div class="item-form-input">
                          <div>
                            <p>
                              <strong>{{ "RelationOwner" | translate }}</strong>
                            </p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                autocomplete="off"
                                formControlName="representativeRelationWithOwner"
                                maxlength="50"
                                oninput="value = value.replace(/[^a-zA-Z]/g, '')"
                              />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeRelationWithOwnerControl?.invalid &&
                                (representativeRelationWithOwnerControl?.touched ||
                                  representativeRelationWithOwnerControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeRelationWithOwnerControl.errors?.['required']"
                              >
                                {{ "ObligatoryField" | translate }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="check-form representante"
                    *ngIf="isOwnerOnSite == false"
                  >
                    <mat-checkbox
                      class="check"
                      [color]="task.color"
                      formControlName="canTakeDecision"
                    ></mat-checkbox>
                    <div class="text-check">
                      {{ "Representative" | translate }}
                    </div>
                  </div>

                  <!-- TERMS AND CONDITIONS -->
                  <div
                    class="check-form"
                    *ngIf="recievedBrand !=='8' && getTermsAndCondition.Observations !==''"
                  >
                    <div class="text-check" [innerHTML]="getTermsAndCondition.Observations" >
                      {{getTermsAndCondition.Observations}}
                    </div>
                  </div>
                  <div
                    class="check-form"
                  >
                    <mat-checkbox
                      formControlName="terms"
                      class="check"
                      [color]="task.color"
                    ></mat-checkbox>
                    <div class="text-check" [innerHTML]="getTermsAndCondition.Description">
                      {{getTermsAndCondition.Description}}
                    </div>
                  </div>

                  <div
                    class="check-form"
                  >
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check" [innerHTML]="getTermsAndCondition.DataProcessingPolicy">
                      {{getTermsAndCondition.DataProcessingPolicy}}
                    </div>
                  </div>

                  

                  <!-- Philippines MercedezBenz terms and conditions -->

                  <!-- Panama termn and conditions -->

                  <!-- <div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'Panama'"
                  >
                    <div class="text-check">
                      Recomendaciones:
                      <li>
                        El Servicio de Taller móvil y Buzón nocturno solo serán
                        ofrecidos mediante el Contact Center de la marca.
                      </li>
                      <li>
                        Las reparaciones y diagnósticos se realizan de Lunes a
                        Viernes en días laborales.
                      </li>
                      <li>
                        Es importante estar a la hora programada para realizar
                        la recepción del auto a través de un asesor de
                        servicios, el tiempo máximo de espera será de 10
                        minutos. Posterior a este rango, la recepción pasará a
                        tiempo de espera para ser atendido según disponibilidad
                        o podría ser reprogramada la cita.
                      </li>
                      <li>
                        Es necesario retirar del vehículo todos sus objetos o
                        pertenencias, el Asesor de Servicio no podrá recibir el
                        auto, Inchcape Motores Japoneses, no se hace responsable
                        por la pérdida de artículos personales, contenidas en el
                        auto.
                      </li>
                      <br />
                    </div>
                  </div> -->

                  <!-- <div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'Panama'"
                  >
                    <mat-checkbox
                      formControlName="terms"
                      class="check"
                      [color]="task.color"
                    ></mat-checkbox>
                    <div class="text-check">
                      <a
                        class="them-blue"
                        href="https://www.suzukipan.com/terminos-y-condiciones"
                        target="_blank"
                        >Términos y Condiciones | Suzuki Panama</a
                      >
                    </div>
                  </div>-->

                  <!--<div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'Panama'"
                  >
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      En Inchcape Panamá también conocida como Motores Japoneses
                      S.A, valoramos y respetamos la confidencialidad sobre sus
                      datos personales. Como parte de nuestro compromiso de
                      transparencia y cumplimiento con la normativa de
                      protección de datos aplicable, solicitamos su
                      consentimiento para el tratamiento de sus datos personales
                      de acuerdo con los siguientes términos:
                      <ul>
                        <li>
                          <b>Responsable del tratamiento: </b>Inchcape Panamá
                          también conocida como Motores Japoneses S.A ubicada en
                          ciudad Panamá, calle 50 Este y Vía Cincuentenario.
                        </li>
                        <li>
                          <b>Datos personales recopilados:</b> En el contexto de
                          nuestras actividades comerciales, podemos recopilar y
                          tratar los siguientes datos personales:
                          <ul>
                            <li>
                              Nombre, dirección, número de teléfono, dirección
                              de correo electrónico, numero de cedula de
                              identidad o pasaporte.
                            </li>
                          </ul>
                        </li>

                        <li>
                          <b>Finalidad del tratamiento: </b>Tratar y/o compartir
                          mi información con empresas relacionadas de la marca,
                          para recibir información:
                          <ul>
                            <li>De los servicios post venta</li>
                            <li>Campañas de recalls;</li>
                            <li>Promociones o marketing y;</li>
                            <li>
                              Otros para la debida información del consumidor en
                              relación con los productos que ofrecemos.
                            </li>
                          </ul>
                        </li>
                      </ul>
                      Declaro que he sido informado acerca del propósito del
                      almacenamiento de mis datos personales contenidos en el
                      sitio web y autorizo su tratamiento de conformidad con la
                      ley 81 de Protección de datos personales y su
                      reglamentación

                      <br />
                    </div>
                  </div> -->

                  <!-- Terminos y condiciones chile Geely -->

                  <!--<div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'ChileGeely'"
                  >
                    <mat-checkbox
                      formControlName="terms"
                      class="check"
                      [color]="task.color"
                    ></mat-checkbox>
                    <div class="text-check">
                      Acepto
                      <a
                        class="them-blue"
                        href="https://www.geely.cl/politica-de-proteccion-de-datos"
                        target="_blank"
                        >Términos y Condiciones</a
                      >
                    </div>
                  </div>-->

                  <!--<div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'ChileGeely'"
                  >
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      Mediante el presente autorizo a Inchcape Chile a tratar
                      y/o compartir mi información con sociedades relacionadas y
                      concesionarios autorizados de la marca, para recibir
                      información relevante y/o encuestas, entre otros. Declaro
                      que he sido informado acerca del propósito del
                      almacenamiento de mis datos personales contenidos en el
                      presente instrumento y autorizo el tratamiento de
                      conformidad lo regula la ley 19.628 de protección de datos
                      de carácter personal.
                    </div>
                  </div>-->

                  <!-- Terminos y condiciones chile subaru -->

                  <!--<div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'ChileSubaru'"
                  >
                    <div class="text-check">
                      Recomendaciones:
                      <li>
                        Servicio Express, es un novedoso y conveniente tipo de
                        servicio que hemos creado especialmente para ti, en el
                        cual podrás realizar la mantención de tu Subaru en sólo
                        90 minutos y así, conservar la seguridad y la
                        confiabilidad con que fue originalmente fue fabricado.
                      </li>
                      <br />
                    </div>
                  </div>
                  <div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'ChileSubaru'"
                  >
                    <mat-checkbox
                      formControlName="terms"
                      class="check"
                      [color]="task.color"
                    ></mat-checkbox>
                    <div class="text-check">
                      Acepto
                      <a
                        class="them-blue"
                        href="https://www.subaru.cl/terminos-y-condiciones-politica-de-privacidad-y-proteccion-de-datos"
                        target="_blank"
                        >Términos y Condiciones</a
                      >
                    </div>
                  </div>-->

                  <!--<div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'ChileSubaru'"
                  >
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      Mediante el presente autorizo a Inchcape Chile a tratar
                      y/o compartir mi información con sociedades relacionadas y
                      concesionarios autorizados de la marca, para recibir
                      información relevante y/o encuestas, entre otros. Declaro
                      que he sido informado acerca del propósito del
                      almacenamiento de mis datos personales contenidos en el
                      presente instrumento y autorizo el tratamiento de
                      conformidad lo regula la ley 19.628 de protección de datos
                      de carácter personal.
                    </div>
                  </div>-->

                  <!-- Terminos y condiciones chile DFSK -->

                  <!-- <div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'ChileDfsk'"
                  >
                    <mat-checkbox
                      formControlName="terms"
                      class="check"
                      [color]="task.color"
                    ></mat-checkbox>
                    <div class="text-check">
                      Acepto
                      <a
                        class="them-blue"
                        href="https://www.dfsk.cl/terminos-y-condiciones/politica-de-proteccion-de-datos-personales"
                        target="_blank"
                        >Términos y Condiciones</a
                      >
                    </div>
                  </div>-->

                  <!--<div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'ChileDfsk'"
                  >
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      Mediante el presente autorizo a Inchcape Automotríz Chile
                      S.A. a tratar y/o compartir mi información con empresas
                      relacionadas y concesionarios autorizados de la marca,
                      para recibir información de servicios de post venta,
                      campañas de recalls, promocionales o marketing y otros
                      para la debida información del consumidor en relación al
                      producto. Declaro que he sido informado acerca del
                      propósito del almacenamiento de mis datos personales
                      contenidos en el presente instrumento y autorizo su
                      tratamiento de conformidad lo regula la Ley 19.628 de
                      Protección de Datos de Carácter Personal.
                    </div>
                  </div>-->

                  <!-- Terminis y condiciones costarica  -->

                  <!--<div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'CostaricaSuzuki'"
                  >
                    <mat-checkbox
                      formControlName="terms"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      <a
                        class="them-blue"
                        href="https://www.suzuki.cr/terminos-y-condiciones"
                        target="_blank"
                        >Términos y Condiciones | Suzuki Costa Rica</a
                      >
                    </div>
                  </div>-->

                  <!-- <div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'CostaricaChangan'"
                  >
                    <mat-checkbox
                      formControlName="terms"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      <a
                        class="them-blue"
                        href="https://www.changan.cr/terminos-y-condiciones"
                        target="_blank"
                        >· Términos y condiciones | changan</a
                      >
                    </div>
                  </div>-->

                  <!-- <div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'CostaricaJac'"
                  >
                    <mat-checkbox
                      formControlName="terms"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      <a
                        class="them-blue"
                        href="https://www.jac.cr/terminos-y-condiciones"
                        target="_blank"
                        >· Términos y condiciones (jac.cr)</a
                      >
                    </div>
                  </div>-->

                  <!-- <div
                    class="check-form"
                    *ngIf="TermAndConditiosMode.includes('Costarica')"
                  >
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      En Inchcape Costa Rica también conocida como Vehículos de
                      Trabajo S.A, valoramos y respetamos la confidencialidad
                      sobre sus datos personales. Como parte de nuestro
                      compromiso de transparencia y cumplimiento con la
                      normativa de protección de datos aplicable, solicitamos su
                      consentimiento para el tratamiento de sus datos personales
                      de acuerdo con los siguientes términos:
                      <ul>
                        <li>
                          <b>Responsable del tratamiento: </b>Inchcape Costa
                          Rica también conocida como Vehículos de Trabajo S.A
                          ubicada en San José la Uruca, frente al hospital
                          México.
                        </li>
                        <li>
                          <b>Datos personales recopilados:</b> En el contexto de
                          nuestras actividades comerciales, podemos recopilar y
                          tratar los siguientes datos personales:
                          <ul>
                            <li>
                              Nombre, dirección, número de teléfono, dirección
                              de correo electrónico, numero de cedula de
                              identidad o pasaporte.
                            </li>
                          </ul>
                        </li>

                        <li>
                          <b>Finalidad del tratamiento: </b>Tratar y/o compartir
                          mi información con empresas relacionadas de la marca,
                          para recibir información:
                          <ul>
                            <li>De los servicios post venta</li>
                            <li>Campañas de recalls;</li>
                            <li>Promociones o marketing y;</li>
                            <li>
                              Otros para la debida información del consumidor en
                              relación con los productos que ofrecemos.
                            </li>
                          </ul>
                        </li>
                      </ul>
                      Declaro que he sido informado acerca del propósito del
                      almacenamiento de mis datos personales contenidos en el
                      sitio web y autorizo su tratamiento de conformidad con la
                      ley 8968 de Protección de la persona frente al tratamiento
                      de sus datos personales.

                      <br />
                    </div>
                  </div>-->
                  <!--<div
                    class="check-form"
                    *ngIf="TermAndConditiosMode === 'MercedezBenz'"
                  >
                    <mat-checkbox
                      formControlName="terms"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      I accept
                      <a
                        class="them-blue"
                        href="https://www.mercedes-benz.ph/terms-and-condition/"
                        target="_blank"
                      >
                        Terms and Conditions
                      </a>
                    </div>
                  </div>-->
                  <!--<div
                    class="check-form"
                    *ngIf="TermAndConditiosMode.includes('Mercedez')"
                  >
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      I declare that I know and understand the
                      <!-- TODO: ADD LINK FOR DATA PROTECTION POLICY -->
                      <!--<a
                        class="them-blue"
                        href="https://www.mercedes-benz.ph/privacy-statement/"
                        target="_blank"
                      >
                        personal data protection policy
                      </a>
                      and I expressly authorize the processing of my personal
                      data.
                    </div>
                  </div>
                 
                </div>
                 <!-- Terminos y condiciones Derco Chile  -->
                 <!-- <div
                 class="check-form"
                 *ngIf="TermAndConditiosMode === 'ChileDerco'"
                 >
                   <mat-checkbox
                     formControlName="terms"
                     class="check"
                     [color]="task.color"
                   ></mat-checkbox>
                   <div class="text-check">
                     Acepto
                     <span class="them-blue">términos y condiciones</span>
                     <li type="disc">Declaro conocer y entender la <a href="https://www.dercocenter.cl/privacidad-y-tratamiento-de-datos#introduccion" target="_blank">política de Protección de datos personales</a> y autorizo expresamente el tratamiento de mis datos personales</li>
                   </div>
                 
                 </div>
                <div
                class="check-form"
                *ngIf="TermAndConditiosMode === 'ChileDerco'"
              >
                <mat-checkbox
                  formControlName="politics"
                  class="check"
                  [color]="task.color"
                  required
                ></mat-checkbox>
                <div class="text-check">
                  <li>De manera más específica para los agendamientos:</li>
                  <br>
                  <li>La cita de agendamiento previa, no asegura la entrega del vehículo durante el mismo día, la cual está condicionada por el estado del vehículo, el motivo de agendamiento, trabajos, reparaciones y/o mantenimientos a realizarse en el vehículo.</li>
                  <li>El cliente acepta informarse de trabajos y costos adicionales que no estén incluidos durante la recepción del vehículo.</li>
                  <li>El servicio de mantenimiento no incluye flete del vehículo desde el domicilio del cliente a servicio técnico y viceversa.</li>
                  <li>otorgando un margen de espera máximo por atraso de 10 minutos. En caso de retraso mayor a este tiempo, la hora agendada se anulará, perdiendo el uso preferencial por cita.</li>
                  <li>Eventualmente te contactaremos al menos 24 horas antes de tu cita para confirmar asistencia. En caso de no poder asistir, agradecemos anules o reagendes tu hora y así dejar disponibilidad para otro vehículo. </li>
                 </div>
              </div> -->
                <div class="container-btn-reservation">
                  <button
                    mat-raised-button
                    class="btn-reservation"
                    matStepperPrevious
                  >
                    {{ "Back" | translate }}
                  </button>

                  <button
                    mat-raised-button
                    color="primary"
                    class="btn-reservation-sig"
                    type="button"
                    matStepperNext
                    [disabled]="formsValidations()"
                    id="next-step2"
                  >
                    {{ "Next" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          </section>
        </form>
      </mat-step>
      <mat-step [stepControl]="firstFormGroup">
        <ng-template matStepLabel>{{
          "FinalizeReservation" | translate | uppercase
        }}</ng-template>
        <form class="section-finalize-reservation">
          <div class="content-finalize-reservation">
            <h3 class="input-title-blue">
              {{ "VerifyYourDetails" | translate }}
            </h3>
            <div class="container-form-finalize">
              <div class="item-form-finalize">
                <p>
                  <strong>{{ "DocumentType" | translate }}</strong>
                </p>
                <h3>{{ nameDocumentType }}</h3>
              </div>
              <div class="item-form-finalize">
                <p>
                  <strong>{{ "DocumentNo" | translate }}</strong>
                </p>
                <h3>{{ formValidation2.controls.cedula.value }}</h3>
              </div>
              <div class="item-form-finalize">
                <p>
                  <strong>{{ "FirstName" | translate }}</strong>
                </p>
                <h3 class="name-field">{{ formValidation2.controls.nombres.value }}</h3>
              </div>
              <div class="item-form-finalize">
                <p>
                  <strong>{{ "LastName" | translate }}</strong>
                </p>
                <h3 class="name-field">{{ formValidation2.controls.apellidos.value }}</h3>
              </div>
              <div class="item-form-finalize">
                <p>
                  <strong>{{ "Phone" | translate }}</strong>
                </p>
                <h3>{{ formValidation2.controls.celular.value }}</h3>
              </div>
              <div class="item-form-finalize">
                <p>
                  <strong>{{ "Email" | translate }}</strong>
                </p>
                <h3 class="name-field">{{ formValidation2.controls.correo.value }}</h3>
              </div>
              <div
                class="item-form-finalize"
                *ngIf="!isNewUser && formValidation2.controls.vin.value !== ''"
              >
                <p><strong>VIN</strong></p>
                <h3 class="finalize-text-item-vin">
                  {{ formValidation2.controls.vin.value }}
                </h3>
              </div>
            </div>
            <div class="container-btn-reservation">
              <button
                mat-raised-button
                class="btn-reservation"
                matStepperPrevious
              >
                {{ "Back" | translate }}
              </button>

              <button
                mat-raised-button
                class="btn-finalize-reservation"
                type="submit"
                (click)="ejecutarCaptcha()"
                id="next-step3"
              >
                {{ "FinalizeReservation" | translate }}
              </button>
            </div>
          </div>
        </form>
      </mat-step>
    </mat-stepper>
  </div>
  <div *ngIf="isLoadingData">
    <div class="overlay"></div>
    <section class="dialog-loading-container">
      <div class="uploader-status">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
      <p class="dialog__loading-text">{{ "LoadingDataMessage" | translate }}</p>
    </section>
  </div>
</section>
